export const mapCenterSelector = ({mapCenter}) => mapCenter